import {
  Container,
  KeyValuePairs,
  KeyValuePairsProps,
  SpaceBetween,
  StatusIndicator,
} from "@amzn/awsui-components-react";
import { AccountingEvent } from "../../types/events";
import {
  getEMPOrchestrationPlatform,
  getFulfillmentState,
  getPaymentState,
  getRefundState,
  hasPromotions,
  isTvodAccountingEvent,
} from "../../helpers/AccountingEventsUtils";
import { screamingSnakeToTitleCase } from "../../helpers/dbdUtils";
import Item = KeyValuePairsProps.Item;

interface AccountingEventsSummarySectionProps {
  event: AccountingEvent;
}

export function AccountingEventsSummarySection({
  event,
}: AccountingEventsSummarySectionProps) {
  const fulfillmentState = getFulfillmentState(event);
  const paymentState = getPaymentState(event);
  const refundState = getRefundState(event);

  const items: Item[] = [
    {
      label: "Created",
      value: (
        <SpaceBetween direction="horizontal" size="xs">
          {event.creationDate
            ? new Date(event.creationDate).toLocaleString()
            : "Unknown"}
        </SpaceBetween>
      ),
    },
    ...(!isTvodAccountingEvent(event)
      ? [
          {
            label: "Subs ID",
            value: (
              <SpaceBetween direction="horizontal" size="xs">
                {`${event.subscriptionId}:${event.subscriptionPeriod}`}
              </SpaceBetween>
            ),
          },
        ]
      : []),
    {
      label: "Fulfillment Type",
      value: screamingSnakeToTitleCase(event.fulfillmentType || "IMMEDIATE"),
    },
    {
      label: "Fulfillment Status",
      value: (
        <StatusIndicator type={fulfillmentState.status}>
          {fulfillmentState.text}{" "}
          {event.cancellationReason && `- (${event.cancellationReason})`}
        </StatusIndicator>
      ),
    },
    {
      label: "Payment Status",
      value: (
        <StatusIndicator type={paymentState.status}>
          {paymentState.text}
        </StatusIndicator>
      ),
    },
    {
      label: "Promotions",
      value: event ? (
        <StatusIndicator type={hasPromotions(event) ? "success" : "stopped"}>
          {hasPromotions(event) ? "Has Promotions" : "No Promotions"}
        </StatusIndicator>
      ) : (
        <StatusIndicator type="stopped">No Product Data</StatusIndicator>
      ),
    },
    {
      label: "Refund Status",
      value: event ? (
        <StatusIndicator type={refundState.status}>
          {refundState.text}
        </StatusIndicator>
      ) : (
        <StatusIndicator type="stopped">No Product Data</StatusIndicator>
      ),
    },
  ];

  if (event.isEmpOrder) {
    items.push({
      label: "EMP Orchestration Platform",
      value: getEMPOrchestrationPlatform(event),
    });
  }

  return (
    <Container>
      <KeyValuePairs columns={2} items={items} />
    </Container>
  );
}
